var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolBarFlashCards(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20155 11.9605C1.7046 9.80801 3.04671 7.66019 5.19923 7.16324L32.5259 0.854383C34.6784 0.357435 36.8262 1.69954 37.3232 3.85206L47.3744 47.3887C47.8713 49.5412 46.5292 51.689 44.3767 52.186L17.0501 58.4948C14.8975 58.9918 12.7497 57.6497 12.2528 55.4971L2.20155 11.9605ZM30.5 29.1137C30.5 32.1764 28.0172 34.6592 24.9545 34.6592C21.8919 34.6592 19.4091 32.1764 19.4091 29.1137C19.4091 26.051 21.8919 23.5682 24.9545 23.5682C28.0172 23.5682 30.5 26.051 30.5 29.1137ZM58.5306 12.4681L49.3557 41.2788L40.4022 2.49716L55.9329 7.44298C58.0379 8.11332 59.2009 10.3632 58.5306 12.4681Z",
    fill: "#FEDE79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolBarFlashCards);
export default __webpack_public_path__ + "static/media/Icon_ToolBar_FlashCards.53932266ea491d460048d4733afdefca.svg";
export { ForwardRef as ReactComponent };